module.exports = __webpack_public_path__ + "static/media/logo_fmps.4135b6d6.png";